<div class="question-type-tabs">
  <label>Question type*</label>
  <div class="type-buttons">
    <button (click)="setType(_QuizQuestionType.MCQ)" [class.active]="selected === _QuizQuestionType.MCQ">MCQ</button>
    <button (click)="setType(_QuizQuestionType.TRUE_FALSE)" [class.active]="selected === _QuizQuestionType.TRUE_FALSE">True/False</button>
    <button (click)="setType(_QuizQuestionType.OPEN_ENDED)" [class.active]="selected === _QuizQuestionType.OPEN_ENDED">Open Ended</button>
  </div>
</div>